import Input, { InputProps } from "./Input";
import { FlexBox, InputTitle } from "../../style/common";
import styled from "styled-components";

interface TitleAndInputProps extends InputProps {
  title: string;
  score?: boolean;
  inputWidth?: string;
}

export default function TitleAndInput({ 
  title,
  type,
  name,
  value,
  placeholder,
  disabled = false,
  score = false,
  inputWidth,
  height,
  onChange,
  register,
}: TitleAndInputProps) {
  return (
    <FlexBox>
      <InputTitle >
        {score && (
          <ScoreSvg xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6" fill="none">
            <circle cx="3" cy="3" r="3" fill="#263439"/>
          </ScoreSvg>
        )}
        {title}
      </InputTitle>
      <Input
        type={type}
        name={name}
        value={value}
        placeholder={placeholder}
        disabled={disabled}
        width={inputWidth}
        onChange={onChange}
        register={register}
        height={height}
      />
    </FlexBox>
  );
}

const ScoreSvg = styled.svg`
  margin-right: 0.375rem;
`;